import { render, staticRenderFns } from "./notification-template-preview-modal.vue?vue&type=template&id=99ec3f5c"
import script from "./notification-template-preview-modal.vue?vue&type=script&lang=js"
export * from "./notification-template-preview-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports